<template>
  <OArticleCard v-bind="$attrs" class="sm:rounded-md">
    <OArticleVariant name="left" class="rounded-md h-full">
      <template #desktop>
        <OArticleCover :show-video-icon="false" class="rounded-t-md" />
        <div class="p-4 u-center hover:text-link-primary">
          <OArticleTitle class="text-md leading-18 line-clamp-4" />
        </div>
      </template>
      <template #mobile>
        <OArticleCover :show-video-icon="false" />
        <div class="p-4 hover:text-link-primary">
          <OArticleTitle class="text-lg line-clamp-2" />
        </div>
      </template>
    </OArticleVariant>
    <OArticleVariant name="right" class="flex sm:rounded-md h-full">
      <template #desktop>
        <div class="px-4 hover:text-link-primary flex flex-grow items-center">
          <OArticleTitle class="text-13 line-clamp-3" />
        </div>
        <OArticleCover height="80" width="142" :show-video-icon="false" class="rounded-r-md flex-shrink-0" />
      </template>
      <template #mobile>
        <OArticleCover width="160" :show-video-icon="false" class="flex-shrink-0" />
        <div class="u-center pl-4 pr-2 sm:px-2 hover:text-link-primary">
          <OArticleTitle class="text-13 line-clamp-3" />
        </div>
      </template>
    </OArticleVariant>
  </OArticleCard>
</template>
<script>
import OArticleCard from '@/modules/card/components/ArticleCard';
import OArticleCover from '@/modules/card/components/ArticleCover';
import OArticleTitle from '@/modules/card/components/ArticleTitle';
import OArticleVariant from '@/modules/card/components/ArticleVariant';
export default {
  components: {
    OArticleCard,
    OArticleCover,
    OArticleTitle,
    OArticleVariant,
  },
  inheritAttrs: false,
};
</script>
